import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const city = {
  path: '/moving',
  component: Layout,
  name: 'moving',
  redirect: '/moving/index',
  children: [{
    path: '/moving/index',
    component: () => import('@/views/moving/index'),
    name: 'moving.index',
    meta: {
      title: i18n.t(`message.movement`)
    }
  }, ]
}

export default city